'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styles = require('./Redirect.css');

var Redirect = (_dec = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Redirect, _Component);

  //
  function Redirect(props) {
    (0, _classCallCheck3.default)(this, Redirect);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Redirect.__proto__ || (0, _getPrototypeOf2.default)(Redirect)).call(this, props));

    _this.getRedirectPath = function (r) {
      return {
        '/macroclimate-30': '/macroclimate-50'
      }[r] || '/not-found-404';
    };

    _this.windowRedirect = function () {
      if (typeof window !== 'undefined') {
        window.location.href = '/blog/';
      } else {
        _this.context.router.push('/index-funds');
      }
    };

    _this.state = { location: props.location };
    return _this;
  }
  //


  (0, _createClass3.default)(Redirect, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ location: nextProps.location });
    }
    //

    //

  }, {
    key: 'render',

    //
    value: function render() {
      if (this.state.location.pathname == '/university-retirement-plans-funding-destruction-students-future') {
        this.windowRedirect();
      } else {
        this.context.router.push(this.getRedirectPath(this.state.location.pathname));
      }
      return _react2.default.createElement('div', null);
    }
  }]);
  return Redirect;
}(_react.Component), _class2.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = Redirect;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Redirect/Redirect.js
// module id = 1416
// module chunks = 0